import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

const loadState = (): { organizationId: string; organizationName?: string; } => {
    const savedState = localStorage.getItem('selectedOrganizationForUser');
    return savedState ? JSON.parse(savedState) as { organizationId: string; organizationName?: string; } : { organizationId: '' };
};

const initialState: { organizationId: string; organizationName?: string; } = loadState();

const selectedOrganizationForUserSlice = createSlice({
    name: 'selectedOrganizationForUser',
    initialState,
    reducers: {
        setSelectedOrganizationForUser: (state, action: PayloadAction<{ organizationId: string; organizationName?: string; }>) => {
            localStorage.setItem('selectedOrganizationForUser', JSON.stringify(action.payload));
            return action.payload;
        },
        removeSelectedOrganizationForUser: (state) => {
            localStorage.removeItem('selectedOrganizationForUser');
            return { organizationId: '' };
        },
    },
});

export const { setSelectedOrganizationForUser, removeSelectedOrganizationForUser } = selectedOrganizationForUserSlice.actions;
export default selectedOrganizationForUserSlice.reducer;
export const selectSelectedOrganizationForUser = (state: RootState) => state.selectedOrganizationForUser;